import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { FileApprovalPopup } from './components/ChatPanel/FileApprovalPopup'
import './styles/globals.css'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

// Restore custom theme on load
try {
  const saved = localStorage.getItem('pulse-custom-theme')
  if (saved) {
    const colors = JSON.parse(saved)
    const styleEl = document.createElement('style')
    styleEl.id = 'pulse-custom-theme-style'
    styleEl.textContent = `:root, [data-theme='dark'], [data-theme='light'] {
      ${colors.bg ? `--bg-0: ${colors.bg} !important;` : ''}
      ${colors.bg1 ? `--bg-1: ${colors.bg1} !important;` : ''}
      ${colors.bg2 ? `--bg-2: ${colors.bg2} !important;` : ''}
      ${colors.bg3 ? `--bg-3: ${colors.bg3} !important;` : ''}
      ${colors.bg4 ? `--bg-4: ${colors.bg4} !important;` : ''}
      ${colors.accent ? `--accent: ${colors.accent} !important;` : ''}
      ${colors.accent2 ? `--accent-2: ${colors.accent2} !important;` : ''}
      ${colors.accent3 ? `--accent-3: ${colors.accent3} !important;` : ''}
      ${colors.text ? `--text-0: ${colors.text} !important;` : ''}
      ${colors.text1 ? `--text-1: ${colors.text1} !important;` : ''}
      ${colors.text2 ? `--text-2: ${colors.text2} !important;` : ''}
      ${colors.red ? `--red: ${colors.red} !important;` : ''}
      ${colors.border ? `--border: ${colors.border} !important;` : ''}
      ${colors.border2 ? `--border-2: ${colors.border2} !important;` : ''}
    }
    .app-bg-gradient { display: none !important; }
    .cursor-spot { display: none !important; }
    .pulse-root { background: ${colors.bg || colors.bg1 || '#1a1a2e'} !important; }
    .ai-panel { background: ${colors.bg1 || colors.bg || '#16213e'} !important; }
    `
    document.head.appendChild(styleEl)
  }
} catch {}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <><App /><FileApprovalPopup /></>
  </React.StrictMode>
)

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}
